import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { canAccess } from "./permissions";

export function AuthGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Loading workspace…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export function PermissionGuard({ permission = null }: { permission?: string | null }) {
  const { user } = useAuth();

  if (!user || !canAccess(user, permission)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
